var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightWhite = function SvgArrowRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 15.98 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow-right-white{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow-right-white",
    d: "M21.88,13.489a1.332,1.332,0,0,0-.28-.44L14.939,6.388a1.338,1.338,0,0,0-1.892,1.892l4.4,4.383H7.332a1.332,1.332,0,0,0,0,2.664H17.444l-4.4,4.383A1.338,1.338,0,1,0,14.939,21.6L21.6,14.941a1.377,1.377,0,0,0,.28-1.452Z",
    transform: "translate(-6 -5.996)"
  })));
};
export default SvgArrowRightWhite;